import React, { useState, useEffect } from 'react'
import 'animate.css';
import ResponseMsg from '../general/ResponseMsg';
import '../css/Admin/AddProduct.css';
import Loading from '../general/Loading';


const AddProduct = () => {
  const [response, setResponse] = useState(null);
      // const [products, setProducts] = useState([]);
  const [focusedField, setFocusedField] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newLoading, setNewLoading] = useState(false);
  const [uniqueCategory, setUniqueCategory] = useState([]);
  const [uniqueBrands, setUniqueBrands] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [newBrand, setNewBrand] = useState('');
const [excelFile, setExcelFile] = useState(null);
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [showImgBulkUpload, setShowImgBulkUpload] = useState(false);
  const [formData, setFormData] = useState({
    productName: '',
    productUnit: '',
    barcode: '',
    hsnCode: '',
    category: '',
    mfgDate: '',
    expDate: '',
    image: null,
    purchasePrice: '',
    originalPrice: '',
    sellPrice: '',
    sellPriceTax: 'With tax',
    tax: 'None',
    discountType: 'amount',
    discountGiven: '0',
    description: '',
    prescription: '',
    composition: '',
    brand: '',
    stock: '',
    added_pres: 'no',
  });

  const handleChange = (e) => {
    const { id, value, type, files } = e.target;
    if (type === 'file') {
       const file = files[0];

    if (file) {
      const maxSize = 2 * 1024 * 1024;

      if (file.size > maxSize) {
        setResponse("Image size should not exceed 2MB");
        return;
      }

      setFormData({
        ...formData,
        [id]: files[0]
      });
    }
    } else {
      setFormData({
        ...formData,
        [id]: value
      });
    }
  };

    useEffect(() => {
        const fetchProducts = async () => {
          
            try {
                const response = await fetch(`https://api.kcmstore.in/store/get-product`);
                if (response.ok) {
                    const data = await response.json();
                    const sortedProducts = data.sort((a, b) => b.id - a.id);
                        // setProducts(sortedProducts);
                        setLoading(false);
                        const uniqueCategories = [...new Set(sortedProducts.map(product => product.category))];
                        const uniqueBrands = [...new Set(sortedProducts.map(product => product.brand))];
          setUniqueCategory(uniqueCategories);
          setUniqueBrands(uniqueBrands);
                } else {
                    console.error('Failed to fetch products');
                    setLoading(false);
                  }
            } catch (error) {
                console.error('Error fetching products:', error);
                setLoading(false);
              }
        };

        fetchProducts();
    }, []);

    // const uniqueCategory = [...new Set(products.map(product => product.category))];


  const handleFocus = (e) => {
    setFocusedField(e.target.id); 
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const handleNewCategoryChange = (e) => {
    setNewCategory(e.target.value);
  };

  const handleAddNewCategory = () => {
    if (newCategory.trim()) {
      setFormData({ ...formData, category: newCategory });
      setUniqueCategory((prevCategories) => [...prevCategories, newCategory]);
      setNewCategory('');
      setResponse(`New category added: ${newCategory}`);
      setTimeout(() => {
        setResponse('');
      }, 2000);
    }
  };


    const handleNewBrandChange = (e) => {
    setNewBrand(e.target.value);
  };


    const handleAddNewBrand = () => {
    if (newBrand.trim()) {
      setFormData({ ...formData, brand: newBrand });
      setUniqueBrands((prevBrands) => [...prevBrands, newBrand]);
      setNewBrand('');
      setResponse(`New brand added: ${newBrand}`);
      setTimeout(() => {
        setResponse('');
      }, 2000);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setNewLoading(true);

    const formDataToSubmit = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSubmit.append(key, formData[key]);
    });

    try {
      const response = await fetch('https://api.kcmstore.in/store/add-product', {
        method: 'POST',
        body: formDataToSubmit
      });

      setNewLoading(false);

      if (response.ok) {
        setResponse('Product added successfully!');
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setFormData({
          productName: '',
          productUnit: '',
          barcode: '',
          hsnCode: '',
          category: '',
          mfgDate: '',
          expDate: '',
          image: null,
          purchasePrice: '',
          originalPrice: '',
          sellPrice: '',
          sellPriceTax: 'with tax',
          tax: 'none',
          discountType: '',
          discountGiven: '',
          description: '',
          prescription: '',
              composition: '',
    brand: '',
    stock: '',
          added_pres: 'no'
        })
      } else {
        setNewLoading(false);
        setResponse('Failed to add product.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setNewLoading(false);
      console.error('Error:', error);
    }
  };


const handleExcelUpload = async () => {
  if (!excelFile) {
    setResponse('Please select an Excel file first.');
    setTimeout(() => setResponse(''), 2000);
    return;
  }

  const formData = new FormData();
  formData.append('file', excelFile);

  setNewLoading(true);
        setShowBulkUpload(false);

  try {
    const res = await fetch('https://api.kcmstore.in/store/upload-bulk-data', {
      method: 'POST',
      body: formData,
    });


      const result = await res.json();
    if (res.ok) {
      setResponse(result.message || 'Bulk Products upload success!');
      setShowBulkUpload(false);
      setExcelFile(null);

    } else {
      setShowBulkUpload(false);
      setResponse(result.message || 'Failed to upload file.');
    }
  } catch (err) {
    console.error(err);
    setResponse('An error occurred during file upload.');
  } finally {
        setNewLoading(false);
  setTimeout(() => setResponse(''), 4000);
  }

};



const handleImagesUpload = async () => {
  if (!excelFile || excelFile.length === 0) {
    setResponse('Please select images.');
    return;
  }

  // ✅ MAX 50 images
  if (excelFile.length > 50) {
    setResponse('Maximum 50 images allowed.');
    return;
  }

  const formData = new FormData();

  for (let i = 0; i < excelFile.length; i++) {
    const file = excelFile[i];

    const maxSize = 2 * 1024 * 1024;

    if (file.size > maxSize) {
      setResponse(`Image "${file.name}" exceeds 2MB limit.`);
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

    if (!allowedTypes.includes(file.type)) {
      setResponse(`"${file.name}" is not a valid image (JPG/PNG only).`);
      return;
    }

    formData.append('images', file);
  }

      setShowImgBulkUpload(false);
  setNewLoading(true);

  try {
    const res = await fetch('https://api.kcmstore.in/store/bulk-upload-images', {
      method: 'POST',
      body: formData,
    });

    const result = await res.json();
    setNewLoading(false);

    if (res.ok) {
      setResponse(result.message || 'Images uploaded!');
      setExcelFile(null);
    } else {
      setResponse(result.message || 'Upload failed');
    }
  } catch (err) {
    setNewLoading(false);
    setResponse('Upload error');
  }

  setTimeout(() => setResponse(''), 2000);
};


  return (
    <>
      <section className='pt-4 pb-5 bg-light'>
        <div className='px-4'>
          <div className='d-flex justify-content-between'>
            <div className='d-flex'>
            <p className='sec-heading my-0'>Add Product</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>New</span></div>

<div>
              <button className="login-btn2 me-3" onClick={() => setShowBulkUpload(true)}>Bulk Upload</button>
              <button className="login-btn2" onClick={() => setShowImgBulkUpload(true)}>Upload Images</button>
</div>          </div>

          <form className="row g-3 bg-white mt-4 px-3 py-3 rounded-4" onSubmit={handleSubmit}>
            {/* Product Name */}
            <p className='my-0 fw-semibold'>Product Details</p>

            <div className="col-md-3 add-label-area">
              <label htmlFor="productName" className={`add-label ${formData.productName || focusedField === 'productName' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Product Name</label>
              <input
                type="text"
                className="form-input"
                id="productName"
                placeholder='Product Name'
                value={formData.productName}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>

            {/* Product Unit */}
            <div className="col-md-3 add-label-area">
              <label htmlFor="productUnit"  className={`add-label ${formData.productUnit || focusedField === 'productUnit' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Product Unit</label>
              <input
                type="text"
                className="form-input"
                id="productUnit"
                placeholder='Tablets, Capsules, Gel, Supplements...'
                value={formData.productUnit}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}        
                required
              />
            </div>

            {/* Barcode */}
            <div className="col-md-3 add-label-area">
              <label htmlFor="barcode"  className={`add-label ${formData.barcode || focusedField === 'barcode' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Barcode</label>
              <input
                type="text"
                className="form-input"
                placeholder='Barcode'
                id="barcode"
                value={formData.barcode}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}        
              />
            </div>

            {/* HSN Code */}
            <div className="col-md-3 add-label-area">
              <label htmlFor="hsnCode"  className={`add-label ${formData.hsnCode || focusedField === 'hsnCode' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>HSN Code</label>
              <input
                type="text"
                className="form-input"
                placeholder='HSN Code'
                id="hsnCode"
                value={formData.hsnCode}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}        
              />
            </div>

            {/* Category */}
            <div className="col-md-3 add-label-area">
            <label htmlFor="category"  className={`add-label ${formData.category || focusedField === 'category' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Category</label>
            <select
        id="category"
        className="form-input"
        value={formData.category}
        onChange={handleChange}
        required
      >
        <option value="" disabled>Select Category</option>
        <option value="addNewCategory" className='bg-darkblue cursor-pointer text-light fw-semibold'>Add New Category</option>
        {loading ? (
          <option>Loading...</option>
        ) : (
          // Map over the unique categories
          uniqueCategory.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))
        )}
      </select>

      {formData.category === 'addNewCategory' && (
        <div className="delete-dialog px-2">
          <div className='col-md-4 mx-auto bg-white py-4 px-4 rounded-4'>
            <div className='my-4 add-label-area'>
          <label htmlFor="newCategory"  className={`add-label ${formData.newCategory || focusedField === 'newCategory' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>New Category</label>
          <input
            type="text"
            id='newCategory'
            className="form-input"
            placeholder="Enter New Category"
            value={newCategory}
            onChange={handleNewCategoryChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          </div>
                            <button className='danger-btn'onClick={() => setFormData({ ...formData, category: '' })}>Cancel</button>&nbsp;&nbsp;
          <button type="button" className="success-btn" onClick={handleAddNewCategory}>Add</button>
          </div>
        </div>
      )}
    </div>


            {/* brand */}
            <div className="col-md-3 add-label-area">
            <label htmlFor="brand"  className={`add-label ${formData.brand || focusedField === 'brand' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Brand</label>
            <select
        id="brand"
        className="form-input"
        value={formData.brand}
        onChange={handleChange}
        required
      >
        <option value="" disabled>Select Brand</option>
        <option value="addNewBrand" className='bg-darkblue cursor-pointer text-light fw-semibold'>Add New Brand</option>
        {loading ? (
          <option>Loading...</option>
        ) : (
          // Map over the unique categories
          uniqueBrands.map((brand, index) => (
            <option key={index} value={brand}>
              {brand}
            </option>
          ))
        )}
      </select>

      {formData.brand === 'addNewBrand' && (
        <div className="delete-dialog px-2">
          <div className='col-md-4 mx-auto bg-white py-4 px-4 rounded-4'>
            <div className='my-4 add-label-area'>
          <label htmlFor="newBrand"  className={`add-label ${formData.newBrand || focusedField === 'newBrand' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>New Brand</label>
          <input
            type="text"
            id='newBrand' 
            className="form-input"
            placeholder="Enter New Brand"
            value={newBrand}
            onChange={handleNewBrandChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          </div>
                            <button className='danger-btn' oonClick={() => setFormData({ ...formData, brand: '' })}>Cancel</button>&nbsp;&nbsp;
          <button type="button" className="success-btn" onClick={handleAddNewBrand}>Add</button>
          </div>
        </div>
      )}
    </div>


            {/* Manufacturing Date */}
            <div className="col-md-3 add-label-area">
              <label htmlFor="mfgDate"  className={`add-label ${formData.mfgDate || focusedField === 'mfgDate' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Mfg Date</label>
              <input
                type="date"
                className="form-input"
                id="mfgDate"
                value={formData.mfgDate}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}        
              />
            </div>

            {/* Expiry Date */}
            <div className="col-md-3 add-label-area">
              <label htmlFor="expDate"  className={`add-label ${formData.expDate || focusedField === 'expDate' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Exp Date</label>
              <input
                type="date"
                className="form-input"
                id="expDate"
                value={formData.expDate}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
              />
            </div>

            <div className='mt-4'><p className='my-0 fw-semibold'>Stock & Medicine Image</p></div>

            {/* Stock */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="stock"  className={`add-label ${formData.stock || focusedField === 'stock' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Stock</label>
              <input
                type="number"
                className="form-input"
                id="stock"
                placeholder='Stock'
                value={formData.stock}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>


            {/* Image Upload */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="image"  className={`add-label ${formData.image || focusedField === 'image' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Upload Image</label>
              <input
                type="file"
                className="form-input bg-white py-2"
                id="image"
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>
            
            <div className='mt-4'><p className='my-0 fw-semibold'>Price Details</p></div>

            {/* Purchase Price */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="purchasePrice"  className={`add-label ${formData.purchasePrice || focusedField === 'purchasePrice' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Purchase Price</label>
              <input
                type="number"
                className="form-input"
                id="purchasePrice"
                placeholder='Purchase Price'
                value={formData.purchasePrice}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>

            {/* Original Price */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="originalPrice"  className={`add-label ${formData.originalPrice || focusedField === 'originalPrice' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>MRP</label>
              <input
                type="number"
                className="form-input"
                id="originalPrice"
                placeholder='MRP'
                value={formData.originalPrice}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>

            {/* Sell Price */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="sellPrice"  className={`add-label ${formData.sellPrice || focusedField === 'sellPrice' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Sell Price</label>
              <input
                type="number"
                className="form-input"
                id="sellPrice"
                placeholder='Sell Price'
                value={formData.sellPrice}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              />
            </div>

            <div className='mt-4'><p className='my-0 fw-semibold'>Tax & Discounts</p></div>

            {/* Sell Price Tax */}
            <div className="col-md-3 add-label-area">
              <label  className={`add-label ${formData.sellPriceTax || focusedField === 'sellPriceTax' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`} htmlFor="sellPriceTax">Tax</label>
              <select
                className="form-input"
                id="sellPriceTax"
                value={formData.sellPriceTax}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                required
              >
                <option value="with tax" selected>With Tax</option>
                <option value="without tax">Without Tax</option>
              </select>
            </div>

            {/* Tax Applicable */}
            <div className="col-md-3 add-label-area">
              <label  className={`add-label ${formData.tax || focusedField === 'tax' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`} htmlFor="tax">Tax Applicable</label>
              <select
                className="form-input"
                id="tax"
                value={formData.tax}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                selected
              >
                <option value="none">None</option>
                <option value="GST 0">GST 0%</option>
                                {/* <option value="IGST 0">IGST 0%</option> */}
                                <option value="GST 0.25">GST 0.25%</option>
                                {/* <option value="IGST 0.25">IGST 0.25%</option> */}
                                <option value="GST 3">GST 3%</option>
                                {/* <option value="IGST 3">IGST 3%</option> */}
                                <option value="GST 5">GST 5%</option>
                                {/* <option value="IGST 5">IGST 5%</option> */}
                                <option value="GST 12">GST 12%</option>
                                {/* <option value="IGST 12">IGST 12%</option> */}
                                <option value="GST 18">GST 18%</option>
                                {/* <option value="IGST 18">IGST 18%</option> */}
                                <option value="GST 28">GST 28%</option>
                                {/* <option value="IGST 28">IGST 28%</option> */}
              </select>
            </div>

            {/* Discount Type */}
            <div className="col-md-3 add-label-area">
              <label  className={`add-label ${formData.discountType || focusedField === 'discountType' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`} htmlFor="discountType">Sell Price Discount</label>
              <select
                className="form-input"
                id="discountType"
                value={formData.discountType}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
                selected
              >
                <option value="amount">Amount ₹</option>
                <option value="percent">Percent %</option>
              </select>
            </div>

            {/* Discount Given */}
            <div className="col-md-3 add-label-area">
              <label  className={`add-label ${formData.discountGiven || focusedField === 'discountGiven' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`} htmlFor="discountGiven">Discount Amount</label>
              <input
                type="number"
                className="form-input"
                id="discountGiven"
                placeholder='Disount Amount'
                value={formData.discountGiven}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
              />
            </div>

            <div className='mt-4'><p className='my-0 fw-semibold'>Related Information</p></div>

            {/* Description */}
            <div className="col-md-12 add-label-area">
              <label htmlFor="description"  className={`add-label ${formData.description || focusedField === 'description' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Description</label>
              <textarea
                className="form-input"
                style={{ height: '12em' }}
                id="description"
                placeholder='Enter medicine information & details'
                value={formData.description}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
        required
              />
            </div>

            {/* Description */}
            <div className="col-md-4 add-label-area">
              <label htmlFor="composition"  className={`add-label ${formData.composition || focusedField === 'composition' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Composition</label>
              <textarea
                className="form-input"
                style={{ height: '10em' }}
                id="composition"
                placeholder='Mention detailed medical composition'
                value={formData.composition}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
        required
              />
            </div>


            {/* Prescription */}
            <div className="col-md-4  add-label-area">
              <label htmlFor="prescription"  className={`add-label ${formData.prescription || focusedField === 'prescription' ? 'label-focused animate__animated animate__fadeInUp animate__faster' : ''}`}>Prescription</label>
              <textarea
                className="form-input"
                style={{ height: '10em' }}
                id="prescription"
                placeholder='Describe how to use, dosage, timing & other instructions'
                value={formData.prescription}
                onChange={handleChange}
                onFocus={handleFocus}
        onBlur={handleBlur}
              />
            </div>

<div className="col-md-4 add-label-area">
  <input
    type="checkbox"
    id="added_pres"
    checked={formData.added_pres === 'yes'}
    onChange={(e) => setFormData({
      ...formData,
      added_pres: e.target.checked ? 'yes' : 'no'
    })}
  />
    <label htmlFor="added_pres" className="form-label">&nbsp;&nbsp;Requires Medical Prescription</label><br />
<small className="form-text text-muted">
    Tick this if the medicine requires a valid medical prescription from the buyer.
  </small>
</div>

            {/* Submit Button */}
            <div className="col-12 text-end">
              <button type="submit" className="login-btn2">Add</button>
            </div>
          </form>
        </div>
      </section>

      {response && <ResponseMsg message={response} />}
      {newLoading && <Loading setLoading={setNewLoading} />}

{showBulkUpload && (
  <section className='delete-dialog px-3' onClick={() => setShowBulkUpload(false)}>
    <div
      className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'
      onClick={(e) => e.stopPropagation()}
    >
      <p className='featured-category'>Upload Excel File</p>

      <input
        type='file'
        accept='.xlsx, .xls'
        onChange={(e) => setExcelFile(e.target.files[0])}
        className='form-input bg-white my-4'
      />
      <small className="text-muted">Only .xlsx or .xls formats are supported</small>

      <div className='mt-3'>
        <button className='success-btn' onClick={handleExcelUpload}>Submit</button>&nbsp;&nbsp;
        <button className='danger-btn' onClick={() => setShowBulkUpload(false)}>Go Back</button>
      </div>
    </div>
  </section>
)}


{showImgBulkUpload && (
  <section className='delete-dialog px-3' onClick={() => setShowImgBulkUpload(false)}>
    <div
      className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4'
      onClick={(e) => e.stopPropagation()}
    >
      <p className='featured-category'>Upload Images in Bulk</p>

      <input
        type='file'
         accept='.jpg,.jpeg,.png'
        onChange={(e) => setExcelFile(e.target.files)}
        multiple
        className='form-input bg-white my-4'
      />
      <small className="text-muted">Only .jpg, .jpeg or .png formats are supported</small>

      <div className='mt-3'>
        <button className='success-btn' onClick={handleImagesUpload}>Submit</button>&nbsp;&nbsp;
        <button className='danger-btn' onClick={() => setShowImgBulkUpload(false)}>Go Back</button>
      </div>
    </div>
  </section>
)}


    </>
  );
};

export default AddProduct;
